// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-rqv","colMin":"styles_colMin__3Ydd1"};